import { Chapter, Reveal } from "@/components/Reveal";
import { GhostCTA } from "@/components/CTA";

const KEYWORDS = ["COMMUNITY", "ESPERIENZE", "EVENTI", "IDENTITÀ", "RELAZIONI", "FIDELIZZAZIONE"];

const Experiential = () => (
  <section id="marketing" data-testid="experiential-section" className="relative overflow-hidden bg-ink py-28 text-white lg:py-44">
    <div aria-hidden="true" className="pointer-events-none absolute inset-0">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_85%_15%,rgba(212,175,55,0.07),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(rgba(245,243,238,0.04)_1px,transparent_1px)] [background-size:30px_30px] [mask-image:radial-gradient(55%_60%_at_80%_20%,black,transparent)]" />
    </div>
    <div className="relative mx-auto max-w-[1440px] px-6 lg:px-12">
      <Chapter index="04" label="Marketing esperienziale" dark />
      <Reveal>
        <h2 className="max-w-5xl font-display text-[clamp(2.4rem,6vw,5rem)] font-extrabold leading-[1.02] tracking-tighter">
          Non creare clienti.
          <br />
          Crea <span className="text-accent">appartenenza</span>.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-16 lg:mt-24 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-base leading-relaxed text-white/60 md:text-lg">
              Le persone sono bombardate ogni giorno da messaggi pubblicitari. Essere semplicemente
              visibili non basta più.
            </p>
            <p className="mt-6 text-base leading-relaxed text-white/60 md:text-lg">
              Il marketing esperienziale trasforma il rapporto tra azienda e cliente: dalla semplice
              transazione alla partecipazione.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="mt-12 border-l-2 border-accent pl-6">
            <p className="font-display text-xl font-bold leading-snug tracking-tight md:text-2xl">
              "Quando un cliente sente di appartenere a qualcosa, smette di essere soltanto un cliente."
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-12">
            <GhostCTA to="/contatti" dark testid="experiential-cta">
              Scopri il marketing esperienziale
            </GhostCTA>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <ul data-testid="experiential-keywords">
            {KEYWORDS.map((k, i) => (
              <Reveal key={k} delay={i * 0.06}>
                <li className="group flex items-baseline justify-between border-b border-white/10 py-5 transition-colors duration-500 hover:border-accent/60">
                  <span className="font-display text-3xl font-extrabold tracking-tighter text-white/85 transition-colors duration-500 group-hover:text-accent sm:text-4xl lg:text-5xl">
                    {k}
                  </span>
                  <span className="font-mono text-[11px] tracking-[0.3em] text-white/25">0{i + 1}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Experiential;
